import React, { useEffect, useState } from 'react';
import Layout from '../../Components/Layout';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import {
    useNavigate,
    useParams,
    useLocation,
} from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import sign from '../../Assets/Images/digisign.png'

const ViewInvoice = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();

    const [invoiceData, setInvoiceData] = useState(null);
    const [loading, setLoading] = useState(true);

    // Helper function to clean text and handle line breaks
    const formatTextWithLineBreaks = (text) => {
        if (!text) return '';
        return text.split('\n').map((line, i) => (
            <React.Fragment key={i}>
                {line}
                {i < text.split('\n').length - 1 && <br />}
            </React.Fragment>
        ));
    };

    // ================= FETCH INVOICE BY ID =================
    const fetchInvoiceById = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");

            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/invoices/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log("Invoice Data => ", response.data);
            setInvoiceData(response.data);

        } catch (error) {
            console.error("Fetch Invoice Error => ", error);
            toast.error("Failed To Fetch Invoice");
        } finally {
            setLoading(false);
        }
    };

    // ================= USE EFFECT =================
    useEffect(() => {
        if (id) {
            fetchInvoiceById();
        }
    }, [id]);

    // PDF Download - Completely Fixed Version
    const downloadPDF = async () => {
        const element = document.getElementById('invoicePdf');

        // Show loading indicator
        const downloadBtn = document.querySelector('.btn-primary');
        const originalBtnText = downloadBtn.innerHTML;
        downloadBtn.innerHTML = 'Generating PDF...';
        downloadBtn.disabled = true;

        try {
            // Set temporary styles for better PDF capture
            const originalStyles = {
                width: element.style.width,
                position: element.style.position,
                transform: element.style.transform
            };

            element.style.width = '800px';
            element.style.position = 'relative';

            const canvas = await html2canvas(element, {
                scale: 3,
                useCORS: true,
                backgroundColor: '#ffffff',
                logging: false,
                windowWidth: element.scrollWidth,
                windowHeight: element.scrollHeight,
                onclone: (clonedDoc, element) => {
                    // Fix any styling issues in cloned element
                    const clonedInvoice = clonedDoc.getElementById('invoicePdf');
                    if (clonedInvoice) {
                        clonedInvoice.style.width = '800px';
                        clonedInvoice.style.margin = '0';
                        clonedInvoice.style.padding = '20px';
                    }
                }
            });

            // Restore original styles
            element.style.width = originalStyles.width;
            element.style.position = originalStyles.position;

            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'px',
                format: 'a4'
            });

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = pdfWidth;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            let position = 0;
            let heightLeft = imgHeight;

            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pdfHeight;

            while (heightLeft > 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pdfHeight;
            }

            pdf.save(`${invoiceData.invoiceNo}.pdf`);

        } catch (error) {
            console.error('PDF generation error:', error);
            toast.error('Error generating PDF. Please try again.');
        } finally {
            downloadBtn.innerHTML = originalBtnText;
            downloadBtn.disabled = false;
        }
    };

    // Loading State
    if (loading) {
        return (
            <Layout>
                <div className="backgound-main-content p-5">
                    <div className="text-center fw-bold fs-4">
                        Loading Invoice...
                    </div>
                </div>
            </Layout>
        );
    }

    // Safety Check
    if (!invoiceData) {
        return (
            <Layout>
                <div className="backgound-main-content p-5">
                    <div className="text-center fw-bold fs-4">
                        Invoice Not Found
                    </div>
                </div>
            </Layout>
        );
    }

    return (
        <Layout>
            <div className="backgound-main-content py-4">
                <div className="container-fluid">
                    {/* Top Buttons */}
                    <div className="d-flex justify-content-between mb-3">
                        <button
                            className="btn btn-secondary"
                            onClick={() => navigate(-1)}
                        >
                            Back
                        </button>
                        <button
                            className="btn btn-primary"
                            onClick={downloadPDF}
                        >
                            Download Invoice
                        </button>
                    </div>

                    {/* Invoice - Fixed Version */}
                    <div
                        id="invoicePdf"
                        style={{
                            width: '800px',
                            margin: '0 auto',
                            background: '#fff',
                            border: '1px solid #000',
                            fontFamily: 'Arial, sans-serif',
                            fontSize: '12px',
                            lineHeight: '1.4',
                        }}
                    >
                        {/* Header */}
                        <div style={{ textAlign: 'center', borderBottom: '1px solid #000', padding: '15px' }}>
                            <h2 style={{ margin: '0 0 5px 0', fontSize: '20px', fontWeight: 'bold' }}>
                                RAK SOFTECH PRIVATE LTD
                            </h2>
                            <div style={{ fontSize: '11px' }}>
                                Office no 3, 3rd floor, Mayuri plaza, above SBI, Near Bhoir Hospital,
                                Dange Chowk, Chinchwad Pune 411033
                            </div>
                            <div style={{ fontSize: '11px' }}>
                                email: kavitay@raksoftech.com | Ph: 91 9588614798
                            </div>
                        </div>

                        {/* GST Row */}
                        <div style={{ display: 'flex', borderBottom: '1px solid #000' }}>
                            <div style={{ width: '50%', borderRight: '1px solid #000', padding: '8px', fontWeight: 'bold' }}>
                                GSTIN - {invoiceData.gstin || '27AAHCR9750J1ZS'}
                            </div>
                            <div style={{ width: '50%', textAlign: 'center', padding: '8px', fontWeight: 'bold' }}>
                                GST INVOICE
                            </div>
                        </div>

                        {/* Tenant + Status 
                        <div style={{ display: 'flex', borderBottom: '1px solid #000' }}>
                            <div style={{ width: '50%', borderRight: '1px solid #000', padding: '8px' }}>
                                <strong>Tenant Name:</strong> {invoiceData.tenantName}
                            </div>
                            <div style={{ width: '50%', textAlign: 'center', padding: '8px' }}>
                                <strong>Payment Status:</strong> {invoiceData.paymentStatus}
                            </div>
                        </div>
                        */}

                        {/* Invoice Details */}
                        <div style={{ display: 'flex', borderBottom: '1px solid #000' }}>
                            <div style={{ width: '50%', borderRight: '1px solid #000', padding: '8px' }}>
                                <div><strong>Invoice No:</strong> {invoiceData.invoiceNo}</div>
                                <div><strong>PO:</strong> {invoiceData.po}</div>
                            </div>
                            <div style={{ width: '50%', padding: '8px' }}>
                                <div><strong>DATE:</strong> {invoiceData.date}</div>
                                <div><strong>FOR:</strong> {invoiceData.companyFor}</div>
                            </div>
                        </div>

                        {/* Address */}
                        <div style={{ display: 'flex', borderBottom: '1px solid #000' }}>
                            <div style={{ width: '50%', borderRight: '1px solid #000', padding: '8px' }}>
                                <strong>Bill To:</strong>
                                <div style={{ marginTop: '5px', whiteSpace: 'pre-wrap' }}>
                                    {formatTextWithLineBreaks(invoiceData.billTo)}
                                </div>
                            </div>
                            <div style={{ width: '50%', padding: '8px' }}>
                                <strong>Ship to:</strong>
                                <div style={{ marginTop: '5px', whiteSpace: 'pre-wrap' }}>
                                    {formatTextWithLineBreaks(invoiceData.shipTo)}
                                </div>
                                <div style={{ marginTop: '10px' }}>
                                    <strong>Contact Person:</strong>
                                </div>
                                <div>{invoiceData.contactPerson}</div>
                            </div>
                        </div>

                        {/* Table */}
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f0f0f0' }}>
                                    <th style={{ padding: '8px', textAlign: 'left', width: '50%' }}>
                                        DESCRIPTION
                                    </th>
                                    <th style={{ padding: '8px', textAlign: 'left', width: '25%' }}>
                                        SAC
                                    </th>
                                    <th style={{ padding: '8px', textAlign: 'right', width: '25%' }}>
                                        AMOUNT
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoiceData.items && invoiceData.items.map((item, index) => (
                                    <tr key={item.id || index}>
                                        <td style={{ border: '1px solid #000', padding: '8px' }}>
                                            {item.description}
                                        </td>
                                        <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'center' }}>
                                            {item.sac}
                                        </td>
                                        <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'right' }}>
                                            ₹ {item.price.toLocaleString()}
                                        </td>
                                    </tr>
                                ))}
                                {invoiceData.gstType === "INTER_STATE" && (
                                    <tr>
                                        <td
                                            colSpan="2"
                                            style={{
                                                border: '1px solid #000',
                                                padding: '8px',
                                                textAlign: 'right',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            IGST - 18%
                                        </td>
                                        <td
                                            style={{
                                                border: '1px solid #000',
                                                padding: '8px',
                                                textAlign: 'right'
                                            }}
                                        >
                                            ₹ {invoiceData.igst?.toLocaleString()}
                                        </td>
                                    </tr>
                                )}

                                {invoiceData.gstType === "INTRA_STATE" && (
                                    <>
                                        <tr>
                                            <td
                                                colSpan="2"
                                                style={{
                                                    border: '1px solid #000',
                                                    padding: '8px',
                                                    textAlign: 'right',
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                CGST - 9%
                                            </td>
                                            <td
                                                style={{
                                                    border: '1px solid #000',
                                                    padding: '8px',
                                                    textAlign: 'right'
                                                }}
                                            >
                                                ₹ {invoiceData.cgst?.toLocaleString()}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td
                                                colSpan="2"
                                                style={{
                                                    border: '1px solid #000',
                                                    padding: '8px',
                                                    textAlign: 'right',
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                SGST - 9%
                                            </td>
                                            <td
                                                style={{
                                                    border: '1px solid #000',
                                                    padding: '8px',
                                                    textAlign: 'right'
                                                }}
                                            >
                                                ₹ {invoiceData.sgst?.toLocaleString()}
                                            </td>
                                        </tr>
                                    </>
                                )}
                                <tr>
                                    <td colSpan="2" style={{ border: '1px solid #000', padding: '8px', textAlign: 'right', fontWeight: 'bold' }}>
                                        TOTAL
                                    </td>
                                    <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'right', fontWeight: 'bold' }}>
                                        ₹ {invoiceData.total?.toLocaleString()}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Amount In Words */}
                        <div
                            style={{
                                borderBottom: '1px solid #000',
                                padding: '10px',
                                minHeight: '80px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px',
                            }}
                        >

                            <div
                                style={{
                                    display: 'flex',
                                    gap: '10px',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                }}
                            >
                                <strong>Amount in Word:</strong>

                                <div>
                                    {invoiceData.amountInWords}
                                </div>
                            </div>

                            <p
                                style={{
                                    margin: 0,
                                    fontSize: '11px',
                                    lineHeight: '1.6',
                                    textAlign: 'justify',
                                    borderTop: '1px solid #000',
                                }}
                            >
                                I / we certify that our registration certficate under the GST Act,
                                2017 is in force on the date on which the supply of goods specified
                                in this Tax Invoice is made by me/us & the transaction of supply
                                covered by this Tax Invoice had been effected by me/us & it shall
                                be accounted for in the turnover of supplies while filling of
                                return & the due tax if any payable on the supplies has been paid
                                or shall be paid. Further certified that the particulars given
                                above are true and correct & the amount indicated represents the
                                prices actually charged and that there is no flow additional
                                consideration directly or indirectly from the buyer.
                            </p>

                        </div>


                        {/* Signature */}
                        {/* Signature */}
                        <div
                            style={{
                                display: 'flex',
                                borderBottom: '1px solid #000',
                            }}
                        >

                            {/* Receiver Signature */}
                            <div
                                style={{
                                    width: '50%',
                                    borderRight: '1px solid #000',
                                    padding: '10px',
                                    minHeight: '100px',
                                }}
                            >

                                {invoiceData.receiverSignature && (

                                    <img
                                        src={invoiceData.receiverSignature}
                                        alt="Receiver Signature"
                                        style={{
                                            width: '120px',
                                            height: '60px',
                                            objectFit: 'contain',
                                        }}
                                    />

                                )}

                                <div style={{ marginTop: '10px' }}>
                                    Receiver's Signature
                                </div>

                            </div>

                            {/* Authorized Signature */}
                            <div
                                style={{
                                    borderBottom: '1px solid #000',
                                    padding: '10px',
                                    minHeight: '100px',
                                    textAlign: 'right',
                                }}
                            >

                                <img
                                    src={sign}
                                    alt="Authorized Signature"
                                    style={{
                                        width: '120px',
                                        height: '60px',
                                        objectFit: 'contain',
                                    }}
                                />

                                <div style={{ marginTop: '10px' }}>
                                    Authorized Signatory
                                </div>

                            </div>
                        </div>

                        {/* Footer */}
                        <div style={{ textAlign: 'center', fontWeight: 'bold', padding: '10px', fontSize: '14px' }}>
                            THANK YOU FOR YOUR BUSINESS!
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default ViewInvoice;